import { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './cases.css';
import ImageTrigger from "./imageTrigger";


function MainCard({selection, onIndexChange = f => f}) {

    const { data, isLocal, setModal  } = useContext(dataContext);
    const [changed, setChanged] = useState(false);



    let urlPrefix = "/images/";
    if (isLocal) urlPrefix = "https://sushi-tunec.com" + urlPrefix;


        const section = data.sectionsdata.find(s => s.nick === 'cases');
        const paragraph = section ? section.paragraphsdata.find(p => p.nick === 'cases1') : [];
        const galerydata = paragraph.galerydata;
        const gal = paragraph.galerydata[selection];
        const text = gal.text;


        useEffect(() => {
        setChanged(true)
        }, [onIndexChange])


    return (

            <motion.div
                initial={{ opacity: 0, rotateY: 0 }}
                animate={{opacity: changed ? 0 : 1, rotateY: changed ? 180 : 0 }}
                transition={{ duration: 0.2 }}
                onAnimationComplete={() => {
                    setChanged(false);
                }}
                className="mainCard"
            >
            <div className="galery-main__imagecontainer"
            >
                <div className="galery-main__image" style={{ backgroundImage: `url(${urlPrefix + gal.image})` }}>


                <div className="galery-main__imagetriggers">

                    {

                        galerydata.map((gal, index) => (

                            <ImageTrigger key={index} index={index} selected={selection == index} onSelect = {onIndexChange} />

                        ))

                    }

                </div>
                <div className="galery-main__imagetext">
                    <span className="galery-main__deliverytime">{text[6]}</span>
                    <span className="galery-main__guests">{text[7]}</span>
                </div>
            </div>
            </div>


            <div className="galery-main__text">
                <div className="galery-main__text1">
                    <span className="galery-main__city">{text[0]}</span>
                    <span className="galery-main__payback"><span>{text[1]}</span></span>
                    <span className="galery-main__revenue"><span>{text[2]}</span></span>
                        <span className="galery-main__profit"><span>{text[3]}</span></span>
                </div>

                <div className="galery-main__text2">
                    <span className="galery-main__reviews">{text[4]}</span>
                    <span className="galery-main__averagebill">{text[5]}</span>
                    <button onClick={() => setModal(true)}>Хочу так же</button>
                </div>
            </div>

            </motion.div>
        )


    }

export default MainCard;